module.exports = __webpack_public_path__ + "img/boy-dosing.6d79dbd4.png";